import { useEffect } from "react";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import Ternary from "src/components/ternary";
import useSettings from "src/hooks/useSettings";
import SocialLinksDialog from "src/components/social-links-dialog";
import Horizontal from "./components/horizontal";
import Vertical from "./components/vertical";

const Layout = () => {
  const config = JSON.parse(localStorage.getItem("menu") || "[]");

  const { themeLayout } = useSettings();
  const verticalLayout = themeLayout === "vertical";
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  useEffect(() => {
    const verifyMsg = sessionStorage.getItem("user_verify_message");
    if (verifyMsg) {
      enqueueSnackbar(t(verifyMsg), { variant: "success" });
      sessionStorage.removeItem("user_verify_message");
    }
  }, [enqueueSnackbar, t]);

  return (
    <>
      <Ternary
        when={verticalLayout}
        then={<Vertical navConfig={config} />}
        otherwise={<Horizontal navConfig={config} />}
      />
      <SocialLinksDialog />
    </>
  );
};
export default Layout;
